import { createStructuredSelector } from "reselect";

const firstName = state => state.getIn(["info", "firstname"], "");
const lastName = state => state.getIn(["info", "lastname"], "");
const email = state => state.getIn(["info", "email"], "");
const state = state => state.getIn(["info", "state"], "");
const program = state => state.getIn(["info", "program"], "");

export const userData = createStructuredSelector({
  firstName,
  lastName,
  email,
  state,
  program
});



// WEBPACK FOOTER //
// ./src/components/shared/redux/selector.js